module.exports = __webpack_public_path__ + "static/media/patient-avatar-2.9241c463.svg";